import React, { useEffect, useRef } from 'react';
import ResetPasswordForm from '../components/ResetPasswordForm';
import { useAuth } from '../context/AuthContext';

export const ResetPassword = () => {
  const { user, logout } = useAuth();
  const hasCheckedInitialUser = useRef(false);

  useEffect(() => {
    // Only logout existing user on initial mount, not after successful login
    if (!hasCheckedInitialUser.current) {
      hasCheckedInitialUser.current = true;
      if (user) {
        logout();
      }
    }
  }, [user, logout]);

  return <ResetPasswordForm />;
};
